import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router';

const SideMenuItem = ({item,selectedMenu,openMenu,}) => {
  // const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const user = useSelector((state)=>state.user);
  const location = useLocation();
  const pathname = location.pathname;


  const isOpen = selectedMenu === item.name;

  const handleClick = () => {
    if(item.onClick){
      if(item.disabled) return;
      item.onClick();
    }else if (item.path) {
      if(item.disabled) return;
      navigate(item.path);
    }else {
      if(item.disabled) return;
      openMenu(item.name);
    }
  };

  const handleSubClick = (subItem) => {
    if (subItem.onClick) {
      if(subItem.disabled) return;
      subItem.onClick();
    }else{
      if(subItem.disabled) return;
      navigate(subItem.path);
    }
  }

  const filteredSubmenu = item.submenu?.filter(subItem => subItem.roles.includes(user.role));

  return (
    <>
      <li className={`nav-item`}>
        <div className={`nav-link ${ isOpen || (pathname && (pathname.split("/")[1].toLowerCase().includes(item.match) || pathname.split("/")[1].toLowerCase().includes(item.name.toLowerCase()))) ? "selected" : ""}`} onClick={handleClick}>
          <FontAwesomeIcon className='me-2' icon={item.icon} />
          <div className="side-menu-text">{item.name}</div>
          {item.submenu && (
            <FontAwesomeIcon
              icon={isOpen ? faChevronDown : faChevronRight}
              className="float-right"
            />
          )}
        </div>
        {isOpen && filteredSubmenu && (
          <ul className="submenu">
            {filteredSubmenu.map((subItem, index) => (
              <li key={index} className="nav-item" onClick={() => handleSubClick(subItem)}>
                <div className={`nav-link ${pathname && subItem.path && (pathname.toLowerCase().includes(subItem.match)||pathname.toLowerCase().includes(subItem.path.toLowerCase())) ? "selected" : ""}`}>
                  <FontAwesomeIcon className='ms-2 me-2' icon={subItem.icon} />
                  <div className="side-menu-text">{subItem.name}</div>
                </div>
              </li>
            ))}
          </ul>
        )}
      </li>
      <hr className="sidebar-divider my-0" />
    </>
  )
}

export default SideMenuItem